import { lazy } from 'react';
import { authModules } from 'app/auth';
import ABSUtils from '@abs/utils/ABSUtils';
import themesConfig from 'app/configs/themesConfig';

const Trips = lazy(() => import('./Trips'));

const TripsConfig = {
    settings: {
        layout: {
            config: {}
        },
        theme: {
            main: ABSUtils.IsDarkMode() ? themesConfig.exkursioDark : themesConfig.exkursio,
            navbar: ABSUtils.IsDarkMode() ? themesConfig.exkursioDark : themesConfig.exkursio,
        }
    },
    routes: [
        {
            path: '/eo/trips',
            element: <Trips />,
            auth: authModules.eo_default
        }
    ]
};

export default TripsConfig;